import { customApiCall, getApiHost, IOptions } from '../utils/api';
import { API_ENDPOINTS } from '../constants/api';
import { UserProfileResponse } from '../types/profile';

/**
 * Get user profile data
 */
export const getUserProfile = (): Promise<UserProfileResponse> => {
    const opts: IOptions = {
        method: "GET",
    };
    return customApiCall(getApiHost(), API_ENDPOINTS.GET_USER_DATA, opts);
};
